import Immutable from "immutable";
import { COLLECTION_SHAPE } from "../../../config/shapes";
import { CLEAR_UNRETURNED_AMOUNT, FLAG_GETTING_UNRETURNED_AMOUNT, GET_UNRETURNED_AMOUNT } from "../../../actions/types";

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_UNRETURNED_AMOUNT:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_UNRETURNED_AMOUNT:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_UNRETURNED_AMOUNT:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    default:
      return state;
  }
};